import { Modal } from "./Modal.js";

/**
 * `shared → private` 的二次确认（spec §4.2 `PERM-2`）。
 *
 * 文案**逐条列出后果**：对方看不到什么、已写的回应会怎样、已读状态会怎样。
 * 这不是一句「确定吗」，而是一次把承诺说清楚的机会 —— 改回私密后，
 * 对方的回应**不删除只隐藏**、已读**保留**，这两条必须被用户读到。
 */
export function VisibilityPrivateModal({
  partnerName,
  replyCount,
  onCancel,
  onConfirm,
  busy = false,
}: {
  partnerName: string;
  /** 对方已写的回应条数；`null` = 还不知道（不显示具体数字）。 */
  replyCount: number | null;
  onCancel: () => void;
  onConfirm: () => void;
  busy?: boolean;
}) {
  return (
    <Modal title="改为仅自己可见？" onClose={onCancel}>
      <p className="modal-lead">
        这篇日记现在共享给{partnerName}了。改回私密后：
      </p>
      <ul className="modal-list">
        <li>
          <b>{partnerName}将无法再看到这篇日记</b>，包括标题、正文与照片
        </li>
        <li>
          {replyCount !== null && replyCount > 0 ? (
            <>
              {partnerName}已写的 <b>{replyCount} 条回应不会被删除</b>
              ，但会随这篇日记一起在 TA 的视图中隐藏
            </>
          ) : (
            <>
              {partnerName}已写的回应（如果有）<b>不会被删除</b>
              ，但会随这篇日记一起在 TA 的视图中隐藏
            </>
          )}
        </li>
        <li>TA 已读的状态会保留，将来改回共享时仍然可见</li>
      </ul>
      <p className="modal-note">你随时可以再改回共享。</p>
      <div className="modal-actions">
        <button type="button" className="btn btn-ghost" onClick={onCancel}>
          取消
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? "处理中…" : "改为仅自己可见"}
        </button>
      </div>
    </Modal>
  );
}
